<template>
    <div class="stat-country">
        <ElCard>
            <ElForm :model="query" ref="formRef" label-width="80px">
                <ElRow :gutter="10">
                    <ElCol :span="24" v-if="query.country === 1">
                        <ElFormItem label="国家" prop="country_code">
                            <ElRadioGroup v-model="query.country_code" @change="getData">
                                <ElRadioButton v-for="item in countryCodeOptions" :key="item.value" :label="item.label" :value="item.value" />
                            </ElRadioGroup>
                        </ElFormItem>
                    </ElCol>
                </ElRow>
            </ElForm>
        </ElCard>
        <ElCard>
            <ElTable 
                :data="list" 
                v-loading="loading" 
                :key="key" 
                @row-click="rowClick" 
                :default-sort="defaultSort" 
                @sort-change="sortChange"
            >
                <ElTableColumn prop="name" label="厂商名称" />
                <ElTableColumn prop="total" label="APP总数" width="150" sortable="custom"/>
                <ElTableColumn prop="download" label="下载量" width="200" sortable="custom" :formatter="numFormat"/>
            </ElTable>
        </ElCard>
        <div class="fixed-pagination">
            <ElPagination
                v-model:current-page="query.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="query.page_size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                background
            />
        </div>
    </div>
</template>

<script setup>
import { ElCard, ElRow, ElCol, ElForm, ElFormItem, ElRadioButton, ElRadioGroup, ElMessage, ElTable, ElTableColumn, ElPagination } from 'element-plus';
import { reactive, ref, onBeforeMount } from 'vue';
import { countryCodeOptions} from './options';
import { getStatCountrysApi } from '@/api/stat_country';
import { useRouter } from 'vue-router';
import { bigNumFormat } from '@/utils/tools/format';

const router = useRouter();
const defaultPage = 1;
const defaultSize = 100;
const loading = ref(false)
const query = reactive({
    id: undefined,
    name: '',
    by: 'name',
    country: 1,
    country_code: "US",
    page: 1,
    page_size: 10,
    order_field: '',
    order_sort: ''
})
const total = ref(0)

const list = ref([])
const getData = async()=>{
    loading.value = true;
    const resp = await getStatCountrysApi(query);
    list.value = resp.data.data.records;
    total.value = resp.data.data.total;
    console.log(list.value)
    loading.value = false;
    ElMessage.success('查询成功');
}
onBeforeMount(()=>{
    getData();
})

// 页面条数变化
const handleSizeChange = (size) => {
    query.page_size = size;
    getData();
}
// 翻页
const handleCurrentChange = (page) => {
    query.page = page;
    getData();
}
const rowClick = (row)=>{
    var param = "";
    param = JSON.stringify({
        type: 1, // 1=all records
        name: row.name,
        page: defaultPage,
        pageSize: defaultSize,
    });

    let routeUrl = router.resolve({
    name: "manufacturerList",
    query: {
        switchStatus: false,
        listQuery: param,
    },
    });
    window.open(routeUrl.href, "_blank");
}
// 排序
const sortChange = (e) => {
    if(!e.order){
        // 取消排序
        query.order_field = '';
        query.order_sort = '';
        getData();
        return
    }
    const sort = e.prop === 'total' ? 'num' : e.prop;
    query.order_field = sort;
    query.order_sort = e.order === 'ascending' ? 'asc' : 'desc';
    getData();
}
// 格式化数字
const numFormat = (row, column, cellValue)=>{
    return bigNumFormat(cellValue);
}
</script>

<style scoped>
.stat-country{
    display: flex;
    width: 100%;
    flex-direction: column;
    margin-top: 10px;
    row-gap: 20px;
    margin-bottom: 100px;
}

</style>